<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="[permissionService.Permission.device_create]"
    sb-button-primary
    type="button"
    color="green"
    icon="plus"
    [disabled]="loading()"
    [iconButton]="true"
    sbTooltip="{{ 'lang.globals.create' | translate }}" container="body"
    (click)="createDevice()">
  </button>
  <button
    type="button"
    sb-button-primary
    icon="refresh"
    [iconButton]="true"
    [color]="'blue'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
    placement="top">
  </button>
  <button
    *ngPermissions="permissionService.Permission.device_export"
    sb-button-primary
    type="button"
    [color]="'blue'"
    [icon]="'download'"
    [disabled]="loading()"
    [sbTooltip]="'lang.globals.exportAll' | translate"
    (click)="showSideBar= true; isSelectedDevicesExport = false;"
    [iconButton]="true"
  ></button>
  <button
    sb-button-primary
    type="button"
    [color]="'blue'"
    [disabled]="loading()"
    [sbTooltip]="'lang.globals.columnOptions' | translate"
    (click)="openColumnOptionModal(applyColumns.bind(this))"
    [iconButton]="true"
    [icon]="'columns'"
  >
    <!-- <div>{{ selectedColumns?.length }}</div>
    <sb-icon class="tw-ml-2" icon="columns"></sb-icon>
    -->
  </button>
</ng-container>

<!------------------------------

      Settings Modal

------------------------------->

<ng-template [sbmodal]="'devlistdevsettingsmodal'">
  <sb-custom-modal [templateId]="'devlistdevsettingsmodal'">
    <sb-comp-settings [modal]="'devlistdevsettingsmodal'" slot="body">
    </sb-comp-settings>
  </sb-custom-modal>
</ng-template>

<!------------------------------

    Side Panel

------------------------------->

<sb-comp-side-panel
  (showChange)="showSideBar = $event" [show]="showSideBar"
  [sidebarHeader]="sidePanelHeaderExport"
  [sidebarTemplate]="sidePanelTemplateExport"
  [sidebarFooter]="sidePanelFooterExport"
  [width]="600">

</sb-comp-side-panel>

<ng-template #sidePanelHeaderExport>
  <h4>{{ 'lang.globals.createDevicesReport' | translate }}</h4>
</ng-template>

<ng-template #sidePanelTemplateExport>
  <form [formGroup]="form" class="">
    <div class="form-group validateMe">
      <label class="form-label" for="Title">{{ 'lang.globals.title' | translate }}</label>
      <input type="text" id="Title" class="form-control" formControlName="Title"
             sbAutofocus>
    </div>
  </form>
</ng-template>

<ng-template #sidePanelFooterExport>
  <div class="tw-flex tw-justify-between">
    <button
      sb-button-secondary
      type="button"
      [color]="'red'"
      [icon]="'cancel'"
      (click)="showSideBar = false; form.reset()"
    >{{ 'lang.globals.cancel' | translate }}
    </button>
    <button
      sb-button-secondary
      type="button"
      [color]="'blue'"
      [icon]="'save'"
      [disabled]="form.invalid"
      (click)="export()"
    >{{ 'lang.globals.save' | translate }}
    </button>
  </div>
</ng-template>

<!------------------------------

     Table Wrapper

------------------------------->

@let isExpanded = checkExpansion();
<sb-table-wrapper-new
  (paginationChange)="requestDebounced($event)"
  [headerClasses]="['stickyHeader']"
  [isInModalContext]="isInModalContext||selectionMode"
  [itemName]="'devices'" [itemsData]="devices"
  [loading]="loading()"
  [isFilterPanelOpen]="isExpanded"
  class="tw-w-full"
  [isMultiSelectEnabled]="selectedDevices()?.size > 0"
  headline="{{'lang.headlines.devices' | translate}}">
  <!------------------------------

    Filter

------------------------------->
  <div filter-panel class="dark:tw-bg-sbGray-930 tw-bg-[#F8F9FC] tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >
      <sb-filter-section
        [alwaysExpanded]="true"
        title="{{'lang.globals.statusFilter' |translate}}" icon="toggleOn"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-toggle filterID="online" [default]="true" [label]="'lang.globals.online' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="currentlyOffline" [default]="true"
                          [label]="'lang.globals.recOnline' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="plannedOffline" [default]="true"
                          [label]="'lang.globals.plannedOffline' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="offline" [default]="true" [label]="'lang.globals.offline' | translate"></sb-filter-toggle>
        <sb-filter-toggle filterID="unknown" [default]="true" [label]="'lang.globals.unknown' | translate"></sb-filter-toggle>
      </sb-filter-section>
      <sb-filter-section
        title="{{'lang.globals.filterAttributes' |translate}}" icon="wrench"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-threeway-toggle filterID="paired" [default]="null"
                                   [label]="'lang.globals.paired' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="noSIM" [default]="null"
                                   [label]="'lang.globals.noSim' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="productive" [default]="null"
                                   [label]="'lang.globals.productive' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="tempDisabled" [default]="null"
                                   [label]="'lang.globals.tempDisabled' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="external" [default]="null"
                                   [label]="'lang.globals.external' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="service" [default]="null"
                                   [label]="'lang.globals.service' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="hasPool" [default]="null"
                                   [label]="'lang.attributeToggles.device.hasPool' | translate"></sb-filter-threeway-toggle>
        <sb-filter-threeway-toggle filterID="hasLocation" [default]="null"
                                   [label]="'lang.attributeToggles.device.hasLocation' | translate"></sb-filter-threeway-toggle>
      </sb-filter-section>
      @if (permissionService.hasPermission(permissionService.Permission.tag_list)) {
        <sb-filter-section title="Tags"
                           icon="tags">
          <sb-filter-dto-list-select filterID="tags" [endpoint]="api.shared_Tag_getTags.bind(api)">
          </sb-filter-dto-list-select>
        </sb-filter-section>
      }
      @if (permissionService.hasPermission(permissionService.Permission.cull_list)) {
        <sb-filter-section title="{{'lang.globals.playerCull' | translate}}"
                           icon="playerOnline">
          <sb-filter-dto-list-select filterID="playerCulls" [endpoint]="api.cs_Cull_retrieveAll.bind(api)"
                                     [endpointOptions]="{type: 'PlayerCull'}">
          </sb-filter-dto-list-select>
        </sb-filter-section>
      }
      @if (permissionService.hasPermission(permissionService.Permission.pool_list)) {
        <sb-filter-section title="{{'lang.globals.pools' | translate}}"
                           icon="pools">
          <sb-filter-dto-list-select filterID="pools" [endpoint]="api.ss_nm_Pool_retrieveAll.bind(api)">
          </sb-filter-dto-list-select>
        </sb-filter-section>
      }
      @if (permissionService.hasPermission(permissionService.Permission.channel_list)) {
        <sb-filter-section
          title="{{'lang.globals.channels' | translate}}" icon="stele">
          <sb-filter-dto-list-select filterID="channels" [endpoint]="api.ss_nm_Channel_retrieveAll.bind(api)">
          </sb-filter-dto-list-select>
        </sb-filter-section>
      }
      @if (permissionService.hasPermission(permissionService.Permission.location_list)) {
        <sb-filter-section
          title="{{'lang.globals.locations' | translate}}" icon="location">
          <sb-filter-dto-list-select filterID="locations" [endpoint]="api.ss_fm_Location_retrieveAll.bind(api)">
          </sb-filter-dto-list-select>
        </sb-filter-section>
      }

      <div class="tw-mx-3">
        <div
          #filterPanelNearbyDevices
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-transition-all tw-ease-in-out tw-group tw-w-fit tw-text-nowrap"
          [ngClass]="{'tw-cursor-pointer': !isExpanded}"
          (click)=" !isExpanded?openFilterPanel(filterPanelNearbyDevices):scrollToFilterPanelElement(filterPanelNearbyDevices)">
          <sb-icon class="tw-text-xl tw-transition-all tw-duration-500" [ngClass]="{'tw-ml-2.5': !isExpanded}"
                   icon="locationStreet"></sb-icon>
          <div class="tw-duration-500 tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.devices.nearbyDevices' | translate }}
          </div>
        </div>

        @if (isExpanded) {
          <div class="tw-mt-2"
               [ngClass]="{
                'tw-opacity-0 tw-w-0': !isExpanded,
                'tw-opacity-100 tw-w-auto': isExpanded,
                }">
            <input type="range" class="tw-w-full" [disabled]="!userService.userGeoLocation" [max]="11"
                   [min]="1" [step]="1" [(ngModel)]="radiusValue" (ngModelChange)="requestDebounced()">
            <div>
              {{ radiusValue === 11 ? ('lang.globals.showAllDevices'|translate) : ('lang.globals.devicesWithin'|translate: { radius: radiusValue }) }}
            </div>
          </div>
        }
      </div>
      <hr>
      <div class="tw-mx-3 tw-gap-2.5 tw-flex tw-flex-col">
        <div
          #filterPanelOrder
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-transition-all tw-ease-in-out tw-group tw-w-fit"
          [ngClass]="{'tw-cursor-pointer': !isExpanded}"
          (click)="!isExpanded?openFilterPanel(filterPanelOrder):scrollToFilterPanelElement(filterPanelOrder)">
          <sb-icon class="tw-text-xl tw-transition-all tw-duration-500" [ngClass]="{'tw-ml-2.5': !isExpanded}"
                   icon="sort"></sb-icon>
          <div class="tw-duration-500 tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.order' | translate }}
          </div>
        </div>
        <div class="tw-flex tw-gap-2.5">

          @let fpOrderOption = filterPanelOrderOption();
          <sb-button-dropdown
            [selectedValue]="fpOrderOption.value" [items]="allOrderOptions|omit: 'direction'"
            (outputChange)="setToOrderFilterPanel(filterPanelOrderOption, $event)"
            [openDirection]="'Up'"
            class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out"
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
          >
          </sb-button-dropdown>
          <sb-segment-control
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
            [selectedOption]="{value: fpOrderOption.direction}"
            [options]="[{value: 'asc', icon: 'sortUpFilled' },{value: 'desc', icon: 'sortDownFilled' }]"
            (selectedOptionChange)="setOrderDirectionFilterPanel(filterPanelOrderOption, $event.value)"
          ></sb-segment-control>
        </div>
      </div>

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>

    @let currentOrderOption = orderOption();
    <tr (cdkDropListDropped)="dropListDropped($event, applyColumns.bind(this))" cdkDropList cdkDropListOrientation="horizontal"
        class="noselect">
      @if (!selectionMode) {
        <th class="sticky-col first-col">
          <sb-comp-table-multi-select-button [selectionState]="selectionState()"
                                             (action)="selectAction($event)"></sb-comp-table-multi-select-button>
        </th>
      }
      <th>
        {{ 'lang.globals.status' | translate }}
      </th>
      <th>
        <div (click)="setToOrderConnection('Connection')" class="cursor-pointer d-inline-flex *:tw-mx-1 hover:tw-text-sbBlue-500"
             [ngClass]="{'tw-text-sbBlue-500': currentOrderOption?.value?.id=== 'Connection'}">
          {{ 'lang.globals.connection' | translate }}
          @if (currentOrderOption.value?.id === 'Connection') {
            @if (currentOrderOption.direction === 'desc') {
              <sb-icon icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
            } @else {

              <sb-icon icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            }
          } @else {
            <sb-icon
              icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
          }
        </div>
      </th>
      <th *ngPermissions="[permissionService.Permission.tag_list]">
        Tags
      </th>
      @for (column of selectedColumns; track column.id; let i = $index) {
        <th (cdkDragStarted)="dragStarted($event, i)" [cdkDragData]="column" [cdkDragDisabled]="window.scrollY > 0"
            cdkDrag class="stickyHeaderViewChild" nowrap>
          <div class="tw-flex tw-items-center tw-gap-2">
            @let isColSortingAllowed = isSortingAllowed(column);
            @let isColFilteringAllowed = isFilteringAllowed(column);
            @if (isColSortingAllowed) {
              <div (click)="setToOrderAndRefresh(column)" class="cursor-pointer d-inline-flex *:tw-ml-2 hover:tw-text-sbBlue-500"
                   [ngClass]="{'tw-text-sbBlue-500': currentOrderOption?.value?.id===column?.id}">
                {{ (column.title ?? column.id) |translate }}
                @if (currentOrderOption.value?.id === column?.id) {
                  @if (currentOrderOption.direction === 'desc') {
                    <sb-icon icon="sortDownFilled"></sb-icon>
                  } @else {
                    <sb-icon icon="sortUpFilled"></sb-icon>
                  }
                } @else {
                  <sb-icon icon="sort"></sb-icon>
                }
              </div>
            } @else {
              <div class="">
                {{ (column.title ?? column.id) |translate }}
              </div>
            }
            @if (isColSortingAllowed && isColFilteringAllowed) {
              <div class="vertical-spacer"></div>
            }
            @if (isColFilteringAllowed) {
              <div
                (click)="columnFilter(column, 'deviceFilter')"
                [ngClass]="{'tw-text-sbBlue-500': isFilterClassActive(column), 'tw-animate-ping-bg': !loading() && columnFiltersMap.has(column.id)}"
                class="cursor-pointer tw-flex tw-items-center hover:tw-text-sbBlue-500">
                @if (isFilterClassActive(column)) {
                  <sb-icon [icon]="'funnelFilled'"></sb-icon>
                } @else {
                  <sb-icon [icon]="'funnel'"></sb-icon>

                }
              </div>
              @if (column.type !== 'PROPERTY') {
                <div class="vertical-spacer"></div>
                <sb-icon [icon]="getColumnIcon(column)" [ngbTooltip]="getColumnTypeTitle(column)"
                         class="cursor-help" container="body">
                </sb-icon>
              }
            }
          </div>
          <div *cdkDragPreview class="drag-placeholder dark:tw-text-white">
            {{ (column.title ?? column.id) |translate }}
          </div>
        </th>
      }
      <th class="sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' |translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

     Card Table Header

------------------------------->
  <ng-template #tCardHead>

    <tr (cdkDropListDropped)="dropListDropped($event, applyColumns.bind(this))" cdkDropList cdkDropListOrientation="horizontal"
        class="noselect">
      @if (!selectionMode) {
        <th>
          <sb-comp-table-multi-select-button [selectionState]="selectionState()"
                                             (action)="selectAction($event)"></sb-comp-table-multi-select-button>
        </th>
      }
      @for (column of selectedColumns; track column.id; let i = $index) {
        @let isColSortingAllowed = isSortingAllowed(column);
        @let isColFilteringAllowed = isFilteringAllowed(column);
        @if (isColFilteringAllowed || isColSortingAllowed) {

          <th (cdkDragStarted)="dragStarted($event, i)" [cdkDragData]="column" [cdkDragDisabled]="window.scrollY > 0"
              cdkDrag class="stickyHeaderViewChild" nowrap>
            <div class="tw-flex tw-items-center tw-gap-2">
              @let currentOrderOption = orderOption();
              @if (isColSortingAllowed) {
                <div (click)="setToOrderAndRefresh(column)" class="cursor-pointer d-inline-flex *:tw-ml-2 hover:tw-text-sbBlue-500"
                     [ngClass]="{'tw-text-sbBlue-500': currentOrderOption?.value?.id===column?.id}">
                  {{ (column.title ?? column.id) |translate }}
                  @if (currentOrderOption.value?.id === column?.id) {
                    @if (currentOrderOption.direction === 'desc') {
                      <sb-icon icon="sortDownFilled"></sb-icon>
                    } @else {
                      <sb-icon icon="sortUpFilled"></sb-icon>
                    }
                  } @else {
                    <sb-icon icon="sort"></sb-icon>
                  }
                </div>
              } @else {
                <div class="">
                  {{ (column.title ?? column.id) |translate }}
                </div>
              }
              @if (isColSortingAllowed && isColFilteringAllowed) {
                <div class="vertical-spacer"></div>
              }
              @if (isColFilteringAllowed) {
                <div
                  (click)="columnFilter(column, 'deviceFilter')"
                  [ngClass]="{'tw-text-sbBlue-500': isFilterClassActive(column), 'tw-animate-ping-bg': !loading() && columnFiltersMap.has(column.id)}"
                  class="cursor-pointer tw-flex tw-items-center hover:tw-text-sbBlue-500">
                  @if (isFilterClassActive(column)) {
                    <sb-icon [icon]="'funnelFilled'"></sb-icon>
                  } @else {
                    <sb-icon [icon]="'funnel'"></sb-icon>

                  }
                </div>
                @if (column.type !== 'PROPERTY') {
                  <div class="vertical-spacer"></div>
                  <sb-icon [icon]="getColumnIcon(column)" [ngbTooltip]="getColumnTypeTitle(column)"
                           class="cursor-help" container="body">
                  </sb-icon>
                }
              }
            </div>
            <div *cdkDragPreview class="drag-placeholder dark:tw-text-white">
              {{ (column.title ?? column.id) |translate }}
            </div>
          </th>
        }
      }
    </tr>
  </ng-template>


  <!------------------------------

     SelectionMode

------------------------------->
  <ng-template #tSelectionMode>
    <sb-action-bar [isInModalContext]="isInModalContext">
      <!-- projected info -->
      <div info>
        {{ selectedDevices().size }} {{ 'lang.globals.selected' | translate }}
      </div>

      <!-- deselect button -->
      <button
        deselect
        type="button"
        sb-button-secondary
        [color]="'blue'"
        class="tw-text-nowrap"
        (click)="selectAction('deselectAll')">
        {{ 'lang.multiSelect.deselectAll'|translate }}
      </button>

      <button
        *ngPermissions="permissionService.Permission.device_export"
        actions
        type="button"
        sb-button-primary
        [color]="'blue'"
        icon="download"
        (click)="showSideBar= true; isSelectedDevicesExport = true;"
        [disabled]="loading()|| showSideBar">
        {{ 'lang.globals.exportSelected'|translate }}
      </button>
    </sb-action-bar>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-device>
    <tr [style.height.px]="60" [ngClass]="{'tw-opacity-50': !device.productive}">
      @if (!selectionMode) {

        <td class="sticky-col first-col">
          @let isDeviceSelected = selectedDevices().has(device?.id) ?? false;
          <sb-comp-table-select-button [isSelected]="isDeviceSelected" (action)="selectDevice(device)"></sb-comp-table-select-button>
        </td>
      }
      <td [device]="device" sb-device-online-status-icon>
      </td>
      <td>
        <!-- id/status/... Column -->
        <p [device]="device" class="mb-1" sb-device-online-status>
        </p>
        <!---->
      </td>
      <td *ngPermissions="[permissionService.Permission.tag_list]">
        <sb-tags [dtoId]="device.id" [dtoType]="tagService.TaggableDTO.Device"
                 [tags]="device.tags"></sb-tags>
      </td>
      @for (col of selectedColumns; track col.id) {
        @let column = createTableCell(col, 'Device', device);
        <td>
          <sb-comp-dynamic-table-element [displayColumn]="column" [isInIntegratedContext]="selectionMode"></sb-comp-dynamic-table-element>
        </td>
      }
      <td class="sticky-col last-col">
        <div>
          <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: device}"></ng-container>
        </div>
      </td>
    </tr>
  </ng-template>

  <div *ngIf="isInModalContext" footer-more>
    <div class="row">
      <div class="col-8">
        <div class="row" style="height: 100%; display: flex; align-items: center;">
          <div *ngFor="let e of selectedDevices() | keyvalue" class="col-3">
            <a [innerHTML]="e.value.name | truncate : 25" class="font-weight-bold link mr-2"
               style="white-space: nowrap; height: 30px;"></a>
          </div>
        </div>
      </div>
      <div class="col-4 justify-content-end d-flex align-items-center">
            <span
              class="mr-2 font-weight-bold text-dark">{{ selectedDevices()?.size }} {{ 'lang.globals.productsSelected' | translate }}</span>
        <button (click)="deselectDevices()" [disabled]="selectedDevices()?.size < 1"
                class="btn btn-danger btn-sm mr-1">{{ 'lang.globals.deselectAll' | translate }}
        </button>
        <button (click)="returnSelectedDevices()"
                class="btn btn-primary btn-sm">{{ 'lang.globals.save' | translate }}
        </button>
      </div>
    </div>
  </div>


  <!------------------------------

  Card Element

------------------------------->


  <ng-template #card let-device>
    <sb-table-card [isHalfImgHeight]="true"
                   [classes]="'hover:tw-bg-sbGrayBlue-100 '+ (device.productive? 'tw-bg-sbGray-50/30' : 'tw-opacity-50')">
      <div table-card-header>
        @let isCampaignSelected = selectedDevices().has(device?.id) ?? false;
        <sb-comp-table-select-button [isSelected]="isCampaignSelected" (action)="selectDevice(device)"></sb-comp-table-select-button>
      </div>

      <div table-card-header-more>
        <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: device}"></ng-container>
      </div>
      <div table-card-img>
        <div class="tw-bg-[url(assets/img/devicedetails-bg.jpg)] tw-bg-cover tw-bg-center tw-h-full">
        </div>

      </div>
      <div table-card-body>
        <div
          class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:sm:tw-py-5 *:tw-py-3.5">

          <sb-table-card-element [headline]="'Status'" [orientation]="'left'">
            <div [device]="device" sb-device-online-status-icon></div>
          </sb-table-card-element>
          <sb-table-card-element [headline]="'lang.globals.connection' | translate" [orientation]="'right'">
            <div [device]="device" sb-device-online-status></div>
            <!--
          <sb-comp-device-online-status-card [device]="device"></sb-comp-device-online-status-card>
            -->
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-4" [headline]="'Tags'" [orientation]="'left'">
            <sb-tags [dtoId]="device.id" [dtoType]="tagService.TaggableDTO.Device"
                     [tags]="device.tags"></sb-tags>
          </sb-table-card-element>
          @for (col of selectedColumns; track col.id; let odd = $odd; let last = $last; let index = $index; let count = $count) {
            @let column = createTableCell(col, 'Device', device);
            @let isEvenColumns = (selectedColumns?.length % 2) === 0;
            <sb-table-card-element
              [headline]="column.title ?? column.id | translate"
              [ngClass]="{'!tw-border-0': last || (isEvenColumns && ((selectedColumns?.length - 2) === index)) }"
              [orientation]="odd ? 'right' : 'left'">
              <sb-comp-dynamic-table-element [displayColumn]="column"
                                             [isInIntegratedContext]="selectionMode"></sb-comp-dynamic-table-element>
            </sb-table-card-element>
          }
        </div>
      </div>
    </sb-table-card>
  </ng-template>

</sb-table-wrapper-new>

<ng-template #ActionButtons let-device>
  @if (selectionMode) {
    <button
      *ngPermissions="permissionService.Permission.attachment_attach_to_device"
      type="button"
      sb-button-secondary
      [color]="'blue'"
      [iconButton]="true"
      (click)="elementSelected.emit(device)"
      [sbTooltip]="'lang.globals.linkAttachment' | translate"
      icon="link">
    </button>
  } @else {
    @if (isInModalContext) {
      @let isDeviceSelected = selectedDevices().has(device?.id) ?? false;
      <button
        type="button"
        sb-button-secondary
        [color]="'blue'"
        class="tw-px-2"
        (click)="selectDevice(device)"
      >
        @if (isDeviceSelected) {
          <sb-icon [icon]="'boxChecked'"></sb-icon>
        } @else {
          <sb-icon [icon]="'box'"></sb-icon>
        }
      </button>
    } @else {
      <sb-split-button
        [splitButtonItems]="device?.sbButtons ?? []"
        (selectedAction)="resolveSplitButtonAction(device, $event)"
      ></sb-split-button>
    }
  }

</ng-template>
